import { Box, CardContent, FormControl, Grid } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import CustomFormLabel from "../../../../components/forms/custom-elements/CustomFormLabel";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";

export const AddCV = (props) => {
  let captureForm = useFormikContext();
  const { values } = props;
  return (
    <Box>
      <FormControl
        sx={{
          width: "100%",
        }}
      >
        <Box sx={{ ml: 0, mt: 0 }}>
          <CardContent
            sx={{
              padding: "10px 30px 10px 30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>First Name</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="firstname"
                  name="firstName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  // disabled={view}
                  {...captureForm.getFieldProps("firstName")}
                  error={Boolean(
                    captureForm.touched?.firstName &&
                      captureForm.errors?.firstName
                  )}
                  helperText={
                    captureForm.touched?.firstName &&
                    captureForm.errors?.firstName
                  }
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Middle Name</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="middleName"
                  name="middleName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  // disabled={view}
                  {...captureForm.getFieldProps("middleName")}
                  error={Boolean(
                    captureForm.touched?.middleName &&
                      captureForm.errors?.middleName
                  )}
                  helperText={
                    captureForm.touched?.middleName &&
                    captureForm.errors?.middleName
                  }
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Last Name</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="lastName"
                  name="lastName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  // disabled={view}
                  {...captureForm.getFieldProps("lastName")}
                  error={Boolean(
                    captureForm.touched?.lastName &&
                      captureForm.errors?.lastName
                  )}
                  helperText={
                    captureForm.touched?.lastName &&
                    captureForm.errors?.lastName
                  }
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12}>
                <CustomFormLabel htmlFor="">Attachment </CustomFormLabel>
                <CustomTextField
                  id="cv"
                  name="cv"
                  variant="outlined"
                  fullWidth
                  size="small"
                  type="file"
                  // inputProps={{ accept: "image/*" }}
                  onChange={(event) => {
                    const file = event.currentTarget.files[0];
                    captureForm.setFieldValue("cv", file);
                  }}
                  error={Boolean(
                    captureForm.touched.cv && captureForm.errors.cv
                  )}
                  helperText={
                    captureForm.touched.cv && captureForm.errors.cv
                  }
                  onBlur={() => captureForm.setFieldTouched("cv", true)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </FormControl>
    </Box>
  );
};
